import * as styles from 'styles/atoms/PercentageBadge.css'
import { CompetitiveCategoryInterest } from 'interfaces/accounts'
import cn from 'classnames'

type PercentageBadgeProps =
  & CompetitiveCategoryInterest
  & {
    strokeEnabled?: boolean
    strokeWidth?: number
    warningTheme?: boolean
  }

const STROKE_WIDTH = 4
const VIEWBOX_SIZE = 72

const PercentageBadge = ({ competitiveAccountsCount, allAccountsCount, strokeEnabled, strokeWidth = STROKE_WIDTH, warningTheme }: PercentageBadgeProps) => {
  const strokeRadius = (VIEWBOX_SIZE - strokeWidth) / 2
  const backgroundRadius = (VIEWBOX_SIZE - 2 * strokeWidth) / 2
  const center = VIEWBOX_SIZE / 2

  const circleLength = 2 * Math.PI * strokeRadius
  const strokeOffset = allAccountsCount > 0
    ? circleLength / allAccountsCount * (allAccountsCount - competitiveAccountsCount)
    : 0
  const strokeProps = {
    strokeWidth: allAccountsCount > 0 ? strokeWidth : 0,
    strokeDasharray: String(circleLength),
    strokeDashoffset: strokeOffset,
  }

  const className = cn(
    styles.percentageBadge,
    (competitiveAccountsCount < allAccountsCount && warningTheme) && styles.warning
  )

  return (
    <figure className={ className }>
      <svg viewBox={ `0 0 ${ VIEWBOX_SIZE } ${ VIEWBOX_SIZE }` } className={ styles.svgContainer }>
        { strokeEnabled && (
          <circle
            className={ styles.stroke }
            cx={ center }
            cy={ center }
            r={ strokeRadius }
            { ...strokeProps }
          />
        )}
        <circle
          className={ styles.background }
          cx={ center }
          cy={ center }
          r={ backgroundRadius }
          { ...strokeProps }
        />
      </svg>
      <figcaption className={ cn(styles.labels, { [styles.shrinkText]: allAccountsCount > 9 }) }>
        { competitiveAccountsCount }<i className={ styles.slash }>/</i>{ allAccountsCount }
      </figcaption>
    </figure>
  )
}

export default PercentageBadge
